import styled from 'styled-components';
const FooterMenu = styled.div`
display:block;
width:100%;
background:${props => props.theme.colors.beige};
position:absolute;
bottom:0;
padding: 50px 0px 50px 0px;
`
const LogoWrapper = styled.div`
display: flex;
flex-direction: row;
flex-wrap: nowrap;
justify-content: space-evenly;
width:200px
align-items: center;

`

const Logo = styled.img`
height:50px;
`
const Credit = styled.div`
position:absolute;
bottom:0px;
right:0px;
`

const getAnnee = () => {
    return(new Date(Date.now()).getFullYear())
}

const  Footer= () => {
    return (
    <FooterMenu>
        <LogoWrapper>
            <Logo src="/img/logo_iraa.png" />
            <Logo src="/img/cnrsLogo.png" />
            <Logo src="/img/lyon2Logo.png" />
        </LogoWrapper>
        <Credit>© Theatra {getAnnee()}</Credit>

    </FooterMenu>
    );
}

export default Footer;